import { render, staticRenderFns } from "./yuyan.vue?vue&type=template&id=6eb74446&scoped=true&"
import script from "./yuyan.vue?vue&type=script&lang=js&"
export * from "./yuyan.vue?vue&type=script&lang=js&"
import style0 from "./yuyan.vue?vue&type=style&index=0&id=6eb74446&lang=scss&scoped=true&"
import style1 from "./yuyan.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb74446",
  null
  
)

export default component.exports